'use strict';

angular.module('itPurchasingControllers')

.controller('ItPurchasingStatusFiltersController', ['$scope', function ($scope) {

    $scope.ctxtFilter.withMyRequests = false;

    $scope.filtersOnStatus = [
        {
            id: 'ToAssign',
            name: 'To Assign',
            label: 'label label-blue',
            icon: 'fa fa-user',
            nbCards: function () {
                if (_.isUndefined($scope.nbCards)) return;
                return $scope.nbCards.NbToAssign;
            }
        },
        {
            id: 'ToAuthorize',
            name: 'To Authorize',
            label: 'label label-orange',
            icon: 'fa fa-key',
            nbCards: function () {
                if (_.isUndefined($scope.nbCards)) return;
                return $scope.nbCards.NbToAuthorize;
            }
        },
        {
            id: 'CustodianProcessing',
            name: 'Custodian Processing',
            label: 'label label-green',
            icon: 'fa fa-truck',
            nbCards: function () {
                if (_.isUndefined($scope.nbCards)) return;
                return $scope.nbCards.NbToCustodianProcessing;
            }
        },
        {
            id: 'Cancelled',
            name: 'Cancelled',
            label: 'label label-gray',
            icon: 'fa fa-trash-o',
            nbCards: function () {
                if (_.isUndefined($scope.nbCards)) return;
                return $scope.nbCards.NbCancelled;
            }
        },
        {
            id: 'Completed',
            name: 'Completed',
            label: 'label label-gray',
            icon: 'fa fa-check-square-o'
        }
    ];

    $scope.toggleWithMyRequests = function () {
        $scope.ctxtFilter.withMyRequests = !$scope.ctxtFilter.withMyRequests;
        $scope.searchSystemsEmployees();
    }

    $scope.resetFilter = function () {
        $scope.filterStatus.name = null;
        $scope.searchSystemsEmployees();
    }

    $scope.changeFilter = function (filterStatus) {
        $scope.filterStatus.name = filterStatus.name;
        $scope.searchSystemsEmployees();
    }

    $scope.isFilterStatusActive = function (filterStatus) {
        if (_.isUndefined(filterStatus)) return false;
        return filterStatus.name === $scope.filterStatus.name;
    };
}]);

